import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';

import './outgoingMsgShimmerComponent.css';

const OutgoingMsgShimmerComponent = () => {
  return (
    <div>
      <div className="et-v2-omsc-outgoing-msg">
        <ShimmerComponent />
      </div>
      <div className="et-v2-omsc-outgoing-msg-time">
        <ShimmerComponent />
      </div>
    </div>
  );
};

export default OutgoingMsgShimmerComponent;
